module.exports = __webpack_public_path__ + "media/app_compressed.b84b8910.mp4";